import React from 'react';

import { useI18n } from 'i18n/I18nContext';
import * as Icons from 'static/images/icons';

const HomeOutcomes = () => {
  const { t } = useI18n();
  const items = [
    {
      key: 'tablet',
      icon: Icons.tabletIcon,
      title: t('home.outcomes.oneTitle'),
      body: t('home.outcomes.oneBody'),
    },
    {
      key: 'eye',
      icon: Icons.eyeIcon,
      title: t('home.outcomes.twoTitle'),
      body: t('home.outcomes.twoBody'),
    },
    {
      key: 'quicker',
      icon: Icons.quickerIcon,
      title: t('home.outcomes.threeTitle'),
      body: t('home.outcomes.threeBody'),
    },
  ];

  return (
    <section className="gb-home-section gb-home-outcomes" aria-labelledby="gb-outcomes-heading">
      <div className="container gb-home-section__inner">
        <header className="gb-home-section__intro">
          <h2 id="gb-outcomes-heading" className="gb-home-section__title">
            {t('home.outcomesTitle')}
          </h2>
          <p className="gb-home-section__lede m-0">{t('home.outcomesLede')}</p>
        </header>

        <ol className="gb-outcomes-grid m-0 p-0">
          {items.map((item, index) => (
            <li key={item.key} className="gb-outcome">
              <div className="gb-outcome__icon" aria-hidden>
                <span className="gb-icon-slot">{item.icon}</span>
              </div>
              <p className="gb-outcome__index m-0" aria-hidden>
                {String(index + 1).padStart(2, '0')}
              </p>
              <h3 className="gb-outcome__title m-0">{item.title}</h3>
              <p className="gb-outcome__body m-0">{item.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HomeOutcomes;



// WEBPACK FOOTER //
// ./src/components/home/HomeOutcomes.tsx